import { isAxiosError } from 'axios';

import { ApiValidationErrorType, ValidationErrorType } from './types';

import type { ApiErrorDetails, ApiValidationError } from './types';

export const isApiValidationError = (error: unknown): error is ApiValidationError => {
  const err = error as Partial<ApiValidationError>;
  return Array.isArray(err?.errors) && err.errors.length > 0;
};

const apiErrorTypeToValidationErrorType: Record<string, ValidationErrorType> = {
  [ApiValidationErrorType.FileSizeTooLarge]: ValidationErrorType.ImageFileSizeTooLarge,
  [ApiValidationErrorType.UnsupportedImageType]: ValidationErrorType.ImageUnsupportedType,
  [ApiValidationErrorType.InvalidUrl]: ValidationErrorType.ImageInvalidUrl,
  [ApiValidationErrorType.BlockedHost]: ValidationErrorType.ImageBlockedHost,
};

export const convertApiErrorToDetails = (apiError: ApiValidationError): ApiErrorDetails | null => {
  for (const error of apiError.errors) {
    const validationErrorType = apiErrorTypeToValidationErrorType[error.errorType];
    if (validationErrorType) {
      return {
        errorType: validationErrorType,
        detail: error.detail,
      };
    }
  }

  return null;
};

export const resolveApiError = (error: unknown): ApiErrorDetails | null => {
  if (!isAxiosError(error) || !error.response) {
    return null;
  }

  let errorData = error.response.data;

  // If response is ArrayBuffer, decode it to JSON
  if (errorData instanceof ArrayBuffer) {
    const decoder = new TextDecoder('utf-8');
    const errorText = decoder.decode(errorData);
    try {
      errorData = JSON.parse(errorText);
    } catch {
      return null;
    }
  }

  // Check if it's a validation error and convert to error details
  if (isApiValidationError(errorData)) {
    return convertApiErrorToDetails(errorData);
  }

  return null;
};
